export function handleDragOver(event: DragEvent): void {
  event.preventDefault();
  event.stopPropagation();
}

export function handleDragLeave(event: DragEvent): void {
  event.preventDefault();
  event.stopPropagation();
}

export function handleDrop(event: DragEvent): File | null {
  event.preventDefault();
  event.stopPropagation();
  return event.dataTransfer?.files?.[0] || null;
}
